import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { apiQuery } from 'store/query';

import type { PreviewResponse } from './types';

interface ApiResponse<T> {
  data: T;
  time: number;
  success: number;
}

export const onboardingApi = createApi({
  baseQuery: apiQuery,
  tagTypes: ['Onboarding'],
  reducerPath: 'onboardingApi',
  endpoints: (build) => ({
    previewOnboarding: build.mutation<PreviewResponse, FormData>({
      transformResponse: (response: ApiResponse<PreviewResponse>) =>
        response.data,
      query: (formData) => ({
        method: 'post',
        data: formData,
        url: URL.ONBOARDING_PREVIEW,
      }),
    }),
  }),
});

export const { usePreviewOnboardingMutation } = onboardingApi;

export * from './types';
